import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 shadow-2xl">
          <h1 className="text-3xl font-bold text-white mb-8">Terms of Service</h1>
          
          <div className="text-gray-300 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Acceptance of Terms</h2>
              <p>
                By using Vaulto, you agree to these Terms of Service. If you do not agree to these terms, 
                please do not use our service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Service Description</h2>
              <p>
                Vaulto is a backup service that helps you backup your Instagram content to your personal Google Drive account. 
                We provide tools to sync your posts, reels, and stories for personal backup purposes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">User Responsibilities</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>You must own or have permission to backup the Instagram content you choose to sync</li>
                <li>You are responsible for maintaining the security of your account credentials</li>
                <li>You must not use the service for any illegal or unauthorized purposes</li>
                <li>You must comply with Instagram's and Google's terms of service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Service Availability</h2>
              <p>
                We strive to provide reliable service, but we do not guarantee uninterrupted access. 
                The service may be temporarily unavailable due to maintenance, updates, or technical issues.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Limitation of Liability</h2>
              <p>
                Vaulto is provided "as is" without any warranties. We are not liable for any data loss, 
                service interruptions, or damages resulting from the use of our service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Account Termination</h2>
              <p>
                You may terminate your account at any time by disconnecting your social media accounts. 
                We may suspend or terminate accounts that violate these terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Changes to Terms</h2>
              <p>
                We may update these Terms of Service from time to time. Continued use of the service 
                constitutes acceptance of any changes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Contact Information</h2>
              <p>
                If you have any questions about these Terms of Service, please contact us at legal@vaulto.app
              </p>
            </section>

            <section className="text-sm text-gray-400 mt-8 pt-4 border-t border-white/20">
              <p>Last updated: {new Date().toLocaleDateString()}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms; 